module.exports = __webpack_public_path__ + "files/d3fdfc4a1fea20096ac70ecac7f97ca1.png";